import "./App.css";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";



import ShifuPage from "./component/ShifuPage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ShifuPage />} />
      </Routes>
    </Router>
  );
}

export default App;
